import type { MindboxSerpType } from '@/entities/analytics';
import { BeachLine, BeachType, ChildService, HotelFacility, RestType, WaterActivity } from '@/entities/hotel';
import { ProductType } from '@/shared/config/pages';
import { FilterGroupId, type RatingFilterKey } from '../model/types';

export type SerpMindboxAmenity =
  | { facility: HotelFacility; label: string }
  | { restType: RestType; label: string }
  | { flag: FilterGroupId.NearTheCenter; label: string };

export const SERP_MINDBOX_TYPES: Partial<Record<ProductType, MindboxSerpType>> = {
  [ProductType.TourOffer]: 'main',
};

export const SERP_MINDBOX_BEACH_TYPES: Partial<Record<BeachType, string>> = {
  [BeachType.SandBeach]: 'Песчаный',
  [BeachType.PebbleBeach]: 'Галечный',
};

export const SERP_MINDBOX_AMENITIES: Readonly<Record<string, SerpMindboxAmenity | null>> = {
  lonelyMan: { facility: HotelFacility.LonelyMan, label: 'Принимает одиноких мужчин' },
  nearTheCenter: { flag: FilterGroupId.NearTheCenter, label: 'Близко к центру' },
  nearTheBeach: null,
  withKids: { facility: HotelFacility.WithKids, label: 'Отдых с детьми' },
  forCouples: { facility: HotelFacility.ForCouples, label: 'Идеально для пар' },
  airConditioner: { facility: HotelFacility.AirConditioner, label: 'Кондиционер' },
  wifi: { facility: HotelFacility.Wifi, label: 'Интернет' },
  wellness: { restType: RestType.Wellness, label: 'Оздоровительные туры' },
  pool: null,
  withAnimals: { facility: HotelFacility.WithAnimals, label: 'Отдых с животными' },
  spaAndHealth: { facility: HotelFacility.SpaAndHealth, label: 'Спа' },
  mountains: { restType: RestType.Mountain, label: 'В горах' },
  eco: { restType: RestType.Eco, label: 'Эко отель' },
};

export const SERP_MINDBOX_CHILD_SERVICES: Readonly<Record<ChildService, string>> = {
  [ChildService.Animators]: 'Детская анимация',
  [ChildService.SeaEntry]: 'Удобный вход в море',
  [ChildService.Menu]: 'Детское меню',
  [ChildService.Bed]: 'Детские кроватки',
  [ChildService.Nanny]: 'Услуги няни (платно)',
  [ChildService.Clubs]: 'Детские мини-клубы',
  [ChildService.Pool]: 'Детский бассейн',
  [ChildService.Playroom]: 'Игровая комната',
};

export const SERP_MINDBOX_HOTEL_RATINGS: Readonly<Record<RatingFilterKey, string>> = {
  best: '4.5',
  better: '4.0',
  good: '3.5',
};

export const SERP_MINDBOX_BEACH_LINES: Readonly<Record<BeachLine, number>> = {
  [BeachLine.First]: 1,
  [BeachLine.Second]: 2,
  [BeachLine.Third]: 3,
};

export const SERP_MINDBOX_WATER_ACTIVITIES: Readonly<Record<WaterActivity, string>> = {
  [WaterActivity.OpenPool]: 'Открытый бассейн',
  [WaterActivity.IndoorPool]: 'Крытый бассейн',
  [WaterActivity.HeatedPool]: 'Бассейн с подогревом',
  [WaterActivity.SeaWaterPool]: 'Бассейн с морской водой',
  [WaterActivity.WaterSlides]: 'Водные горки',
  [WaterActivity.Aquapark]: 'Аквапарк',
};
